$(document).ready(function() {

    if ($('.slide-collection').length) {
        $('.slide-collection .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: false,
                loop: true,
                autoHeight: false,
                smartSpeed: 800,
                margin: 0,
                responsive: {
                    0: {
                        dots: true
                    },
                    1250: {
                        dots: false
                    }
                },
                onTranslated: function() { 
                    let slide = $carousel.find('.owl-item.active .item').data('slide');
                    $('.data').fadeOut();
                    $(`.data[data-slide="${slide}"]`).fadeIn();
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });
    }

    page_banner();

});

$(window).scroll(function() {
    page_banner();
});

function page_banner() {
    if ($('.page-banner').length) {
        $('.page-banner').each(function() {
            let el = $(this);

            let title = el.find('.show-up:eq(0)');
            let body = el.find('.show-up:eq(1)');
        
            if (visiblePercent(el) > 20) {
                title.addClass('show');
                setTimeout(function() {
                    body.addClass('show');
                }, 200);
            }
            else {
                title.removeClass('show');
                body.removeClass('show');
            }
        });    
    }
}